import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import RowFourItem from 'components/Utils/RowFourItem'

class RowFour extends Component {
  constructor(props) {
    super(props)
    this.state = { ...props }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps })
  }
  returnClassname(data, title, i) {
    if (data.title.style === 'sectra-light' || i > 0) {
      return 'sectra-light mg-bottom'
    } else {
      return 'mg-bottom'
    }
  }
  render() {
    let data = this.state && this.state.data

    let sectionTitle
    if (data && data.sectionTitle) {
      sectionTitle = <h3>{data.sectionTitle}</h3>
    }

    let bgColor = 'none'
    if (data && data.background) {
      bgColor = data.background
    }

    return (
      <section className="main-grid center" style={{marginTop: '50px', paddingTop: '50px', background: bgColor}}>
        <ul className="grid group">
          {sectionTitle}

          {
            data && data.title.content.map((title, i) => {
            let className = this.returnClassname(data, title, i),
                style = (i > 0) ? {marginBottom: '10vmin'} : {}
            return <h3 key={i} className={className} style={style}>{title}</h3>
            })
          }
          {
            data && data.content.map((el, i) => {
              return (
                <RowFourItem key={i} index={i} data={el} />
              )
            })
          }
        </ul>
      </section>
    )
  }
}
RowFour.contextTypes = {
}
RowFour.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
  }
}

export default connect(mapStateToProps)(RowFour)



// WEBPACK FOOTER //
// ./src/components/Utils/RowFour.js